import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',
    strategies:[]
   
}

const settingReducer = (state = initialState, { type, action, error }) => {
    switch (type) {


        case types.GET_SETTINGS_REQUEST: {
              
            return {
                ...state,
                pending:true,
                settings:null
            }
        }

        case types.GET_SETTINGS_SUCCESS: {
            return {
                ...state,
                pending:false,
                settings:action.data
            }
        }

        case types.GET_SETTINGS_ERROR: {
             
            return {
                ...state,
                error:action.error
            }
        }
        
        case types.UPDATE_SETTINGS_REQUEST: {
              
            return {
                ...state,
                updatePending:true,
            }
        }

        case types.UPDATE_SETTINGS_SUCCESS: {
            return {
                ...state,
                updatePending:false,
                updateSuccess:true
            }
        }

        case types.UPDATE_SETTINGS_ERROR: {
             
            return {
                ...state,
                updatePending:false,

            }
        }

        
        case types.GET_QUEUE_STRATEGIES_REQUEST: {
              
            return {
                ...state,
                getQueueStrategiesPending:true,
            }
        }

        case types.GET_QUEUE_STRATEGIES_SUCCESS: {
            return {
                ...state,
                getQueueStrategiesPending:false,
                strategies:action.data
            }
        }

        case types.GET_QUEUE_STRATEGIES_ERROR: {
             
            return {
                ...state,
                getQueueStrategiesPending:false,

            }
        }


        case types.SETTING_RESET_PROPS: {
            return {
                ...state,
                pending: false,
                updatePending: false,
                updateSuccess:false
            }
        }
        default:
            return state
    }
}

export default settingReducer;